<!-- 一级机构的二级机构服务 -->
<template>
  <div class="contentBox">
    <!-- 表格数据 -->
    <div class="tableBox">
      <!-- 机构管理-->
      <div class="innovationVoucher">
        <img src="@/assets/images/table-tab.png" width="8px" height="23px" />
        <span>机构服务</span>
      </div>
      <!-- Tabs标签组件 -->
      <Tabs :tabs="tabsList" @tab-click="tabClick">
        <!-- 搜索条件 -->
        <jr-search :params="searchParams" @search="handleSearch" @reset="handleSearch"></jr-search>
        <template v-if="currentUsersData.length">
          <JRtable :table-data="currentUsersData" :selection="false" :show-pagination="true"
            :column="currentUsersColumns" size="mini" :border="true" :pageOptions="pageOptions"
            @page-change="handlePageChange" :index="true">
            <template slot="slot_record_tools" slot-scope="data">
              <el-button @click="handleDetail(data.scope.row)" size="mini" type="primary"
                icon="el-icon-view">查看</el-button>
            </template>
          </JRtable>
        </template>
        <template v-else>
          <div style="color: #333333; font-weight: 400; width: 64px; height: 30px; margin: 30px">暂无数据</div>
        </template>
      </Tabs>
    </div>
    <!-- 新增弹框 -->
    <Dialog v-if="showDialog" :visible.sync="showDialog" width="1500px" :title="dialogTitle + '服务基本信息'" :showBtn="true"
      @close="handleCancelForm" :append-to-body="true" @cancel="handleCancelForm">
      <template #content>
        <div class="applyform">
          <el-form :model="exchangeForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <!-- 服务机构信息 -->
            <el-card class="box-cards">
              <div slot="header" class="card-title">
                <div></div>
                <span>服务机构信息</span>
              </div>
              <!-- 服务机构信息 -->
              <el-row :gutter="20">
                <el-col :span="10">
                  <el-form-item label="服务机构名称：" label-width="200px"> <el-input v-model.trim="currentJgInfo.jgmc"
                      style="width: 300px" clearable disabled></el-input> </el-form-item></el-col>
                <el-col :span="10">
                  <el-form-item label="服务机构联系人：" label-width="200px"> <el-input v-model.trim="currentJgInfo.jglxr"
                      style="width: 300px" clearable disabled></el-input> </el-form-item></el-col>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <el-form-item label="服务机构联系电话：" label-width="200px"> <el-input v-model.trim="currentJgInfo.jglxrdh"
                      style="width: 300px" clearable disabled></el-input> </el-form-item></el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col>
                  <el-form-item label="服务机构类型：" label-width="200px">
                    <span v-for="(item, index) in currentJgInfo.fwjglxList" :label="item" :key="item">{{ index + 1 }}、{{
                      item }}<br /></span> </el-form-item></el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col>
                  <el-form-item label="服务领域：" label-width="200px">
                    <!-- <template v-if="currentJgInfo.sscylyDetail != ''">
                      <span> 其他：{{ currentJgInfo.sscylyDetail }}<br /></span>
                    </template> -->
                    <template>
                      <span v-for="(item, index) in currentJgInfo.sszylyList" :key="item"> {{ index + 1 }}、{{ item
                        }}<br /></span>
                    </template> </el-form-item></el-col>
              </el-row>
            </el-card>
            <!-- 服务基本信息 -->
            <el-card class="box-cards">
              <div slot="header" class="card-title">
                <div></div>
                <span>服务基本信息</span>
              </div>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="服务名称：" label-width="200px">
                    <el-input v-model.trim="exchangeForm.fwmc" style="width: 1020px" clearable disabled></el-input>
                  </el-form-item></el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="参考价格(元)：" label-width="200px">
                    <el-input v-model.trim="exchangeForm.ckjg" disabled style="width: 300px" clearable></el-input>
                  </el-form-item></el-col>
                <!-- <el-col :span="10">
                  <el-form-item label="服务来源：" label-width="200px">
                    <el-input disabled v-model.trim="exchangeForm.fwly" style="width: 300px" clearable></el-input>
                  </el-form-item></el-col> -->
                  <el-col :span="12">
                    <el-form-item label="最高价格(元)："  label-width="200px">
                      <el-input-number v-model.trim="exchangeForm.ckjgMax" :min="0" disabled  style="width: 300px">
                      </el-input-number> </el-form-item></el-col>                  
              </el-row>
              <el-row :gutter="20">
                 <el-col :span="12">
                  <el-form-item label="服务类型：" label-width="200px">
                    <el-cascader ref="fAddress2" v-model.trim="exchangeForm.fwlx" :options="options"
                      :props="cityDictProps" style="width: 300px" disabled> </el-cascader>
                  </el-form-item></el-col>             
                <el-col :span="10">
                  <el-form-item label="服务照片：" label-width="200px">
                    <el-upload class="avatar-uploader" action="#" :show-file-list="false" disabled>
                      <img v-if="exchangeForm.fwtpPath" :src="exchangeForm.fwtpPath" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload> </el-form-item></el-col>
              </el-row>
              <el-row :gutter="20" v-if="exchangeForm.fwlx[0] === '01'">
                <el-col>
                  <el-form-item label="应用领域：" prop="yyly" label-width="200px" class="groupClass fwlyStyle">
                    <el-checkbox-group v-model="exchangeForm.yyly" disabled>
                      <el-checkbox v-for="(option, index) in yylyList" :key="index" :label="option.dictCode">{{
                        option.dictValue
                      }}</el-checkbox>
                      <!-- 点击其他按钮才会展示输入框信息 -->
                      <template v-if="exchangeForm.yyly.includes('99')">
                        <el-input v-model.trim="exchangeForm.yylyDetail" style="width: 200px;margin-left: 10px;"
                          size="mini" disabled></el-input>
                      </template>
                    </el-checkbox-group>
                  </el-form-item></el-col>
              </el-row>
              <el-row :gutter="20" v-if="exchangeForm.fwlx[0] === '01'">
                <el-col>
                  <el-form-item label="设备分类（可多选）：" prop="sbfl" label-width="200px" class="groupClass fwlyStyle">
                    <el-checkbox-group v-model="exchangeForm.sbfl" disabled>
                      <el-checkbox v-for="(option, index) in sbflList" :key="index" :label="option.dictCode">{{
                        option.dictValue
                      }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item></el-col>
              </el-row>
              <el-row :gutter="20" v-if="exchangeForm.fwlx[0] === '01'">
                <el-col :span="10">
                  <el-form-item label="设备原值：" prop="sbyz" label-width="200px">
                    <el-input v-model.trim="exchangeForm.sbyz" style="width: 300px" disabled>
                      <template slot="append">万元</template>
                    </el-input>
                  </el-form-item></el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="联系人：" label-width="200px">
                    <el-input disabled v-model.trim="exchangeForm.lxr" style="width: 300px" clearable></el-input>
                  </el-form-item></el-col>
                <el-col :span="12">
                  <el-form-item label="联系人电话：" label-width="200px">
                    <el-input disabled v-model.trim="exchangeForm.lxdh" style="width: 300px" clearable></el-input>
                  </el-form-item></el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="所在地区：" label-width="200px">
                    <el-cascader ref="fAddress" v-model="fwdz" :options="divisionHbDictList" :props="cityDictProps"
                      style="width: 250px" disabled>
                    </el-cascader>
                    <el-input disabled v-model.trim="exchangeForm.lxdz" style="width: 400px;margin-left: 10px;"
                      clearable></el-input>
                  </el-form-item></el-col>
                <!-- <el-col :span="10">
                  <el-form-item label="认证资质:" label-width="200px">
                    <el-input disabled v-model.trim="exchangeForm.rzzz" style="width: 300px" clearable></el-input>
                  </el-form-item></el-col> -->
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="服务简介：" label-width="200px">
                    <el-input disabled v-model="exchangeForm.fwjj" style="width: 840px" type="textarea"
                      :autosize="{ minRows: 5, maxRows: 8 }" maxlength="300" show-word-limit></el-input>
                  </el-form-item></el-col>
                <el-col :span="24">
                  <el-form-item label="服务内容：" label-width="200px">
                    <el-input disabled v-model="exchangeForm.fwnr" style="width: 840px" type="textarea"
                      :autosize="{ minRows: 5, maxRows: 8 }" maxlength="300" show-word-limit></el-input>
                  </el-form-item></el-col>
              </el-row>
            </el-card>
            <!-- 服务资质文件 -->
            <el-card class="box-cards upload-attachments">
              <div slot="header" class="card-title">
                <div></div>
                <span>服务资质文件</span>
              </div>
              <template v-if="wjlxList2.length > 0">
                <el-row :gutter="50" v-for="(item, index) in wjlxList2" :key="index">
                  <el-col :span="12" style="display: flex; flex-direction: column; align-items: flex-start">
                    <div class="up-list_item">
                      <div class="up-list_item_row">
                        <div class="fileName">
                          <span>{{ index + 1 }}、{{ item.wjm }} （{{ item.wjdx | bytesToKB }}）</span>
                          <el-link type="success" @click="previewFile2(item.id)">预览 </el-link>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </template>
              <template v-else>
                <span>暂无相关资质文件</span>
              </template>
            </el-card>
          </el-form>
        </div>
      </template>
      <template #footer>
        <el-button size="small" @click="handleCancelForm">取 消</el-button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { countMyThirdlyJg } from '@/api/mechanism/mySecondJg/index.js'
import { getServiesDetail, getMountJg, getFwlxDictList } from '../../../api/mechanism/myServies'
import JRtable from '@/components/Table'
import Tabs from '@/components/Tabs'
import Dialog from '@/views/enterprise/components/Dialog'
import JrSearch from '@/components/Search'
import { getDictionaryList, recursionDictData } from '@/api/enterprise/exchangelist'
import { printPdfView2 } from '@/api/mechanism/enterApply'
import { getToken } from '@/utils/cache'
export default {
  components: {
    JRtable,
    Tabs,
    Dialog,
    'jr-search': JrSearch,
  },
  created() {
    // 查询湖北省行政区划
    this.handleGetHbDivision()
    // 分页查询我的二级机构服务信息
    this.countMyThirdlyJg()
  },
  data() {
    return {
      searchParams: [
        { type: 'input', field: 'jgmc', label: '机构名称' },
        { type: 'input', field: 'fwmc', label: '服务名称' },
      ],
      searchForm: {},
      cityDictProps: {
        label: 'dictValue',
        value: 'dictCode',
        children: 'childSysDictionaryList'
      },
      // 分页数据
      pageOptions: {
        page: 1,
        limit: 10,
        total: 0
      },
      // 表格数据
      currentUsersData: [],
      currentUsersColumns: [
        {
          label: '机构名称',
          prop: 'jgmc',
          align: 'center',
          // width: 300,
          truncate: true
        },
        {
          label: '服务名称',
          prop: 'fwmc',
          align: 'center',
          // width: 300,
          truncate: true
        },
        {
          label: '联系人',
          prop: 'lxr',
          align: 'center',
          // width: 300,

          truncate: true
        },
        {
          label: '联系方式',
          prop: 'lxdh',
          // width: 300,
          align: 'center',
          truncate: true
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          // fixed: 'right',
          slot: 'slot_record_tools'
        }
      ],
      // 顶部横向tabs切换栏目
      tabsList: [
        // {
        //   id: 0,
        //   value: '机构服务',
        //   isActive: true,
        //   // quantity: 0
        // }
      ],
      //上传文件ID
      fileIdList: [],
      // 是否显示dialog
      showDialog: false,
      // 兑付表单对应的form信息
      exchangeForm: {
        fwid: '', // 服务ID
        fwmc: '', // 服务名称
        fwjj: '', // 服务简介
        lxr: '', // 联系人
        lxdh: '', // 联系电话
        lxdz: '', // 联系地址
        fwszs: '',//服务所在市
        fwszqy: '',//服务所在区
        fwnr: '', // 服务内容
        rzzz: '', // 认证资质
        cjsj: '', // 创建时间
        jgid: '', // 机构ID
        fwlx: [], // 服务类型
        fwzt: '001', // 服务状态
        fbsj: '', // 发布时间
        shsj: '', // 审核时间
        bhsm: '', // 驳回说明
        fwzz: '', // 服务资质
        fwly: '', // 服务来源
        ckjg: '', // 参考价格
        ckjgMax: '', // 最高参考价格
        fwtpPath: '', // 服务图片
        fwtp: '',
        auditState: '', // 审核状态0不通过1通过
        sbfl: [],//设备分类
        sbyz: '',//
        yyly: [],//应用领域
        yylyDetail: '',//应用领域说明
      },
      options: [],
      fileList: [],
      // 当前机构的信息
      currentJgInfo: {
        jgmc: '',
        jglxr: '',
        jglxrdh: '',
        fwjglxList: [],
        sszylyList: []
      },
      // 设备类型数组
      sbflList: [],
      // 应用领域数组
      yylyList: [],
      // 服务地址数组
      fwdz: [],
      // 湖北省行政区划字典
      divisionHbDictList: [],
      cityDictProps: {
        label: 'dictValue',
        value: 'dictCode',
        children: 'childSysDictionaryList'
      },
      wjlxList2: [], //已经上传的文件信息,
    }
  },
  filters: {
    bytesToKB: function (bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      let size = bytes / k
      let unit = 'KB'
      if (size > k) {
        size /= k
        unit = 'MB'
      }
      return size.toFixed(2) + ' ' + unit
    }
  },
  methods: {
    // 查询湖北省行政区划
    handleGetHbDivision() {
      let params = {
        parentId: '420000',
        level: '3'
      }
      recursionDictData(params).then((response) => {
        const { data } = response
        this.divisionHbDictList.push(data)
      })
    },
    // 预览
    async handlePreview(file) {
      // console.log(file)
      const obj = this.fileIdList.filter((item) => {
        return item.name === file.name
      })
      // console.log(obj)
      const url = process.env.VUE_APP_BASE_API + 'sc/ticketMain/api/factFwjbxxb/previewFwzzFile?fileId=' + obj[0].fileId

      window.open(url, '_blank')
    },
    // 分页查询兑付记录
    async countMyThirdlyJg() {
      let params = {
        page: this.pageOptions.page,
        size: this.pageOptions.limit,
        ...this.searchForm
      }
      const result = await countMyThirdlyJg(params)
      if (result.code === 200) {
        this.currentUsersData = result.data.records
        this.pageOptions.total = result.data.total
        // this.tabsList[0].quantity = result.data.total
      } else {
        this.currentUsersData = []
        this.pageOptions.total = 0
        // this.tabsList[0].quantity = 0
      }
    },
    // 搜索条件
    handleSearch(param) {
      this.pageOptions.page = 1
      this.pageOptions.limit = 10
      this.searchForm = { ...param }
      this.countMyThirdlyJg()
    },
    // 分页控制
    handlePageChange(val) {
      this.pageOptions.page = val.page
      this.pageOptions.limit = val.limit
      // 再次获取数据
      this.countMyThirdlyJg()
    },
    // tabs栏目点击切换事件
    tabClick() {
      this.countMyThirdlyJg()
    },
    async handleDetail(data) {
      // 获取所属服务机构信息
      await this.getMountJg(data.jgid)
      // 查询字典值
      await this.getOrgTypeList(data.jgid)
      const result = await getServiesDetail({ fwid: data.fwid })
      this.exchangeForm = JSON.parse(JSON.stringify(result.data))
      // 回显设备分类、设备原值
      this.wjlxList2 = result.data.fwzzList
      this.fwdz = result.data.fwszqy
      // 回显设备分类、设备原值
      // this.wjlxList2 = result.data.fwzzList
      if (result.data.parentFwlxCode === '01') {
        if (result.data.sbfl) {
          // 展示设备分类、设备原值表单信息
          this.exchangeForm.sbfl = result.data.sbfl.split(';')
        } else {
          this.exchangeForm.sbfl = []
        }
        if (result.data.yyly) {
          // 展示应用领域
          this.exchangeForm.yyly = result.data.yyly.split(';')
        } else {
          this.exchangeForm.yyly = []
        }
      }
      this.exchangeForm.fwlx = [result.data.parentFwlxCode, result.data.fwlx]
      this.showDialog = true
      this.dialogTitle = '查看'
    },
    handleCancelForm() {
      this.showDialog = false
      this.$refs.ruleForm.resetFields()
    },
    // 查询机构的服务挂载机构
    async getMountJg(jgid) {
      const result = await getMountJg({
        jgid
      })
      this.currentJgInfo = result.data
    },
    //  获取字典数据
    async getOrgTypeList(jgid) {
      const result = await getFwlxDictList({
        jgid
      })
      this.options = result.data
      // 获取设备分类字典值
      const result2 = await getDictionaryList({
        parentCode: 'DIM_SBFL'
      })
      if (result2.code === 200) {
        this.sbflList = result2.data
      }
      // 获取应用领域字典值
      const result3 = await getDictionaryList({
        parentCode: 'DIM_YYLY'
      })
      if (result3.code === 200) {
        this.yylyList = result3.data
      }
    },
    // 预览文件
    previewFile2(fileId) {
      let params = {
        fileId,
        InternetToken: getToken()
      }
      var paramsStr = Object.keys(params)
        .map((item) => item + '=' + params[item])
        .join('&')
      //预览文件
      window.open(printPdfView2(paramsStr))
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/form.scss';

.contentBox {
  width: 100%;
  height: 100%;

  .tableBox {
    margin-top: 25px;
  }
}

.innovationVoucher {
  font-weight: bold;
  display: flex;
  font-size: 20px;
  color: #333333;
  margin-bottom: 15px;

  span {
    margin-left: 10px;
  }

  :nth-child(3) {
    font-size: 16px;
    font-weight: bold;
    color: #ff0000;
    margin-left: 15px;
  }
}

.tabs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 34px;

  .left {
    display: flex;

    :nth-child(1) {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 29px;
      padding: 5px;
      opacity: 0.75;
      background: #3f7fff;
    }

    :nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-left: 17px;
    }
  }

  .right {
    display: flex;

    :nth-child(1) {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 70px;
      height: 30px;
      border-radius: 5px 5px 5px 5px;
      background: #adadad;
      margin-right: 10px;
      cursor: pointer;
    }

    :nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 70px;
      height: 30px;
      border-radius: 5px 5px 5px 5px;
      background: #3f7fff;
      cursor: pointer;
    }
  }
}

.table-container {
  padding: 15px;
  border: 1px solid rgb(243, 247, 255) !important;
  background: rgb(252, 252, 252);
  margin-bottom: 0px !important;
}

::v-deep .el-form {
  .el-form-item {
    display: flex;
  }

  .el-form-item__content {
    margin-left: 10px !important;
  }
}

.avatar-uploader {
  line-height: 10px;
  border: 1px dashed #d9d9d9 !important;
}

.el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

// 申请表单样式
.applyform {
  padding: 10px;

  .box-cards {
    margin-bottom: 10px;

    .card-title {
      display: flex;
      align-items: center;

      div {
        width: 5px;
        height: 13px;
        background: rgb(88, 155, 248);
        margin-right: 10px;
      }

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}

.groupClass .el-checkbox {
  width: 110px;
}

::v-deep .fwlyStyle {
  .el-form-item__content {
    flex: 1 !important;
  }
}

::v-deep.upload-attachments {
  .el-card__body {
    .el-row {
      min-height: 100px;
      border-bottom: 1px solid rgb(205, 211, 220);
      display: flex;
      align-items: center;

      .upload-title {
        font-weight: bold;
        font-size: 16px;
      }

      .upload-icon {
        cursor: pointer;
        font-size: 16px;
        color: rgb(86, 165, 253);

        i {
          margin-right: 5px;
        }
      }

      .upload-waring {
        color: red;
        font-size: 16px;
      }
    }
  }
}
</style>
